export default __webpack_public_path__ + "static/analysts_Architect_INTJ_workplace_habits-9a78e97ad1c1258054c87c46498f5dd8.svg";